import { ELocalStorageKey } from '/@/types/enums'

export interface PageInfo {
  page_title?: string
  page_title_dksl?: string
  platform_title?: string
  page_logo?: string
  latitude?: number
  longitude?: number
  [key: string]: any
}

export const DEFAULT_PAGE_TITLE = '一网统飞综合管理平台'

function normalizeTitle (title?: string | null) {
  return typeof title === 'string' ? title.trim() : ''
}

function resolvePageTitle (pageInfo: PageInfo = getPageInfo(), fallback = DEFAULT_PAGE_TITLE) {
  return normalizeTitle(pageInfo.page_title) ||
    normalizeTitle(pageInfo.page_title_dksl) ||
    normalizeTitle(pageInfo.platform_title) ||
    fallback
}

export function getResolvedBackendPageTitle (pageInfo: PageInfo = getPageInfo()) {
  return normalizeTitle(pageInfo.page_title) ||
    normalizeTitle(pageInfo.page_title_dksl) ||
    normalizeTitle(pageInfo.platform_title)
}

export function getPageInfo (): PageInfo {
  const value = localStorage.getItem(ELocalStorageKey.LargeScreen)
  if (!value) return {}
  try {
    return JSON.parse(value) || {}
  } catch (error) {
    console.warn('读取页面信息失败:', error)
    return {}
  }
}

export function getPageTitle (fallback = DEFAULT_PAGE_TITLE) {
  return resolvePageTitle(getPageInfo(), fallback)
}

export function cachePageInfo (pageInfo?: PageInfo | null) {
  const safePageInfo = pageInfo || {}
  localStorage.setItem(ELocalStorageKey.LargeScreen, JSON.stringify(safePageInfo))
  syncDocumentTitle(safePageInfo)
}

export function syncDocumentTitle (pageInfo: PageInfo = getPageInfo()) {
  document.title = resolvePageTitle(pageInfo)
}

export function syncDocumentTitleFromCacheIfExists () {
  const title = getResolvedBackendPageTitle(getPageInfo())
  if (title) document.title = title
}
